import { render, staticRenderFns } from "./currencyChart.vue?vue&type=template&id=3b86ea7e"
import script from "./currencyChart.vue?vue&type=script&lang=js"
export * from "./currencyChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports